import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-hoja-usuario',
  templateUrl: './hoja-usuario.component.html',
  styleUrls: ['./hoja-usuario.component.scss']
})
export class HojaUsuarioComponent implements OnInit {
  public isLoadingResults = false;
  public searchString: string = '';
public usuario:any;

  constructor(
    public empresaSvc: EmpresaService,
    public usrSvc: UserService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {}

  ngOnInit(): void {}

  onEnter() {
    console.log('boton enter');
    this.getUsuario();
  }

  getUsuario() {
    this.usrSvc
      .getHojaUsuario({
        empresaId: '00000000-0000-0000-0000-000000000000',
        documento: this.searchString,
      })
      .subscribe((res) => {
        if (res) {
          console.log(res);
          this.usuario=res;
        } else {
          this.usuario=null;
          this.alertify.error(
            'No se ha encontrado el usuario, verifique la información e intentelo de nuevo'
          );
        }
      });
  }

}
